import React from 'react';
import { MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import RecruitWithKitCard from './ComponentFragments/RecruitWithKitCard';


export default class DemonstratorWithKit extends React.Component {

    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.props.loaderOn();
        this.state = {
            recruitData: [],
            filteredData: []
        }
        this.searchList = this.searchList.bind(this);
        this.props.loaderOff();
    }

    searchList(phrase) {
        let arr = [];
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        arr = this.state.recruitData.filter((dem) => (dem.firstNames.toUpperCase().includes(phrase.toUpperCase())) || (dem.surname.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({ filteredData: arr });
    }

    async componentWillMount() {
        var dl = new DataLayer();
        let endPoint = 'getrecruitswithkit';
        if (this.TMAUser.data.statusCode1 == 'T') {
            endPoint = 'getteamrecruitswithkit'
        }
        if (this.TMAUser.data.statusCode1 == 'M') {
            endPoint = 'getunitrecruitswithkit'
        }
        await dl.Get('/demonstrator/' + endPoint, 200).then((response) => {
            this.setState({
                recruitData: response.data,
                filteredData: response.data
            });
            this.props.loaderOff();
        })
    }


    render() {
        let headerText = "Recruits With Kit";
        if (this.TMAUser.data.statusCode1 == 'T') {
            headerText = "Team Recruits With Kit";
        }
        if (this.TMAUser.data.statusCode1 == 'M') {
            headerText = "Unit Recruits With Kit";
        }
        return (
            <div>
                <Header headerText={headerText}
                    placeholderText="Search Recruits"
                    searchList={this.searchList}
                />
                <MDBRow>
                    {
                        this.state.filteredData.map((dem) => {
                            return (
                                <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                    <RecruitWithKitCard
                                        firstNames={dem.firstNames.toUpperCase()}
                                        surname={dem.surname.toUpperCase()}
                                        sfCurrentCode={dem.sfCurrentCode}
                                        startWeekId={dem.startWeekId}
                                        kitWeekId={dem.kitWeekId}
                                        kitSaleDate={dem.kitSaleDate}
                                        invoiceDescription={dem.invoiceDescription}
                                        processingCode={dem.processingCode}
                                        unitName={dem.unitName}
                                    />
                                </MDBCol>


                            );
                        })
                    }
                </MDBRow>


            </div>
        );
    }
}